import { forwardRef } from 'react'
import { IMaskInput } from 'react-imask'

interface NumberMaskProps {
  onChange?: (event: any) => void
  name?: string
  value?: string
}

export const FloatNumberMaskInput = forwardRef<HTMLInputElement, NumberMaskProps>(
  function FloatNumberMask(props, ref) {
    const { onChange, name = '', value, ...other } = props

    const safeValue =
      value === null || value === undefined ? '' : typeof value === 'number' ? String(value) : value

    return (
      <IMaskInput
        {...other}
        value={safeValue}
        mask={Number}
        scale={2}
        radix="."
        mapToRadix={['.']}
        normalizeZeros={true}
        padFractionalZeros={true}
        thousandsSeparator=","
        min={0}
        unmask={true}
        onAccept={(value) => {
          if (value === '') {
            onChange?.({ target: { name, value: '' } })
            return
          }

          let normalized = value

          if (normalized.startsWith('.')) {
            normalized = '0' + normalized
          }

          onChange?.({ target: { name, value: normalized } })
        }}
        inputRef={ref}
        overwrite
      />
    )
  }
)

FloatNumberMaskInput.displayName = 'FloatNumberMaskInput'

export const PercentageMaskInput = forwardRef<HTMLInputElement, NumberMaskProps>(
  function PercentageMask(props, ref) {
    const { onChange, name = '', value, ...other } = props
    const safeValue =
      value === null || value === undefined ? '' : typeof value === 'number' ? String(value) : value
    return (
      <IMaskInput
        {...other}
        value={safeValue}
        inputRef={ref}
        mask={Number}
        scale={2}
        radix="."
        mapToRadix={['.']}
        thousandsSeparator=""
        normalizeZeros={false}
        padFractionalZeros={false}
        min={0}
        max={100}
        onAccept={(value) => {
          let num = parseFloat(value)
          if (isNaN(num)) num = 0
          if (num > 100) num = 100
          onChange?.({ target: { name, value: num > 0 ? num.toString() : '' } })
        }}
        overwrite
      />
    )
  }
)

PercentageMaskInput.displayName = 'PercentageMaskInput'

export const IntegerMaskInput = forwardRef<HTMLInputElement, NumberMaskProps>(
  function IntegerMask(props, ref) {
    const { onChange, name = '', value, ...other } = props
    return (
      <IMaskInput
        {...other}
        value={value == null ? '' : String(value)}
        mask={Number}
        scale={0}
        thousandsSeparator=","
        min={0}
        unmask={true}
        onAccept={(value) => {
          onChange?.({
            target: {
              name,
              value,
            },
          })
        }}
        inputRef={ref}
        overwrite
      />
    )
  }
)

IntegerMaskInput.displayName = 'IntegerMaskInput'

export const CreditMaskInput = forwardRef<HTMLInputElement, NumberMaskProps>(
  function CreditMask(props, ref) {
    const { onChange, name = '', value, ...other } = props
    return (
      <IMaskInput
        {...other}
        value={value == null ? '' : String(value)}
        mask={Number}
        scale={0}
        thousandsSeparator=","
        min={1}
        unmask={true}
        prepare={(str, masked) => {
          const current = (masked.unmaskedValue || '').replace(/,/g, '')
          if (current === '') {
            return str.replace(/^0+/, '') || ''
          }
          return str
        }}
        onAccept={(value) => {
          const num = parseInt(value, 10)
          if (value === '' || isNaN(num) || num < 1) {
            onChange?.({ target: { name, value: '' } })
            return
          }
          onChange?.({
            target: {
              name,
              value,
            },
          })
        }}
        inputRef={ref}
        overwrite
      />
    )
  }
)

CreditMaskInput.displayName = 'CreditMaskInput'
